import React from 'react'
import ChangeUserData from '../../../components/form/changeUserData'

function UserData() {
  return (
      <ChangeUserData/>
  )
}

export default UserData;